import { useContext } from 'react'
import { useLocation } from 'react-router'
import styled, { css } from 'styled-components'
import { CreationToolsContext } from '../manager'
import { getBasePathFromCreationTool } from '../routes'
import CreationTool from '../types/creation-tool'
import CreationToolOutputType from '../types/output-type'
import CreationToolStep from '../types/steps'
import { StickerBlock } from './blocks'

const baseStyles = css`
    display: block;
    height: 100%;
    left: 0;
    opacity: 0.3;
    pointer-events: none;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: -1;
`

const Sticker = styled(StickerBlock as any)`
    ${baseStyles}
`

const Video = styled.video`
    ${baseStyles}
    object-fit: cover;
`

const CreationToolsBackground = () => {
    const { tool, outputType } = useContext(CreationToolsContext)
    const { pathname } = useLocation()
    const basePath = getBasePathFromCreationTool(tool)
    const betaPickerPath = `${basePath}${CreationToolStep.route(CreationToolStep.BetaPicker)}`
    const backgroundVideoUrl = CreationTool.backgroundVideoUrl(tool)

    // show background video (if available) for welcome screen
    if (backgroundVideoUrl && (pathname === basePath || pathname === betaPickerPath)) {
        return <Video src={backgroundVideoUrl} muted playsInline autoPlay loop />
    }

    // show sticker checkerboard background if creating sticker
    if (outputType === CreationToolOutputType.Sticker) {
        return <Sticker />
    }

    return null
}

export default CreationToolsBackground
